document.addEventListener('DOMContentLoaded', () => {
  const swatchContainers = document.querySelectorAll('.card-variant-swatches');

  swatchContainers.forEach(container => {
    const productId = container.dataset.productId;
    const cardWrapper = container.closest('.card-wrapper');
    const mainImageElement = cardWrapper.querySelector(`.product-card-image[data-product-image-for="${productId}"]`);
    const variantIdInput = container.querySelector(`.product-variant-id[data-product-id="${productId}"]`);
    const addToCartButton = container.querySelector(`.add-to-cart-button[data-product-id="${productId}"]`);
    const selectOptionsTextSpan = addToCartButton.querySelector('.add-to-cart-text-select');
    const readyToCartTextSpan = addToCartButton.querySelector('.add-to-cart-text-ready');
    const soldOutTextSpan = addToCartButton.querySelector('.add-to-cart-text-soldout');

    let productVariants, productOptions, defaultMainImage, productVariantMetafields;

    try {
      const variantsJsonEl = document.querySelector(`script[data-product-variants-json-for="${productId}"]`);
      if (variantsJsonEl) productVariants = JSON.parse(variantsJsonEl.textContent);

      const optionsJsonEl = document.querySelector(`script[data-product-options-json-for="${productId}"]`);
      if (optionsJsonEl) productOptions = JSON.parse(optionsJsonEl.textContent);

      const mainImageJsonEl = document.querySelector(`script[data-product-main-image-json-for="${productId}"]`);
      if (mainImageJsonEl) defaultMainImage = JSON.parse(mainImageJsonEl.textContent);

      const variantMetafieldsEl = document.querySelector(`script[data-product-variants-metafields-json-for="${productId}"]`);
      if (variantMetafieldsEl) productVariantMetafields = JSON.parse(variantMetafieldsEl.textContent);

    } catch (e) {
      console.error('Error parsing product JSON for card:', productId, e);
      return;
    }

    if (!productVariants || !productOptions) {
      console.warn('Missing product variants or options data for card:', productId);
      return;
    }

    const currentSelectedOptions = {};
    productOptions.forEach((option, index) => {
      currentSelectedOptions[`option${index + 1}`] = null;
    });

    container.querySelectorAll('.variant-swatch-group').forEach(group => {
      const optionIndex = parseInt(group.dataset.optionIndex, 10);
      const selectedValueSpan = group.querySelector(`.selected-option-value-${optionIndex}`);

      group.querySelectorAll('.swatch-value').forEach(button => {

        button.addEventListener('click', function() {
          const value = this.dataset.value;
          const isActive = this.classList.contains('active');

          // Deselect other buttons in the same group
          group.querySelectorAll('.swatch-value').forEach(btn => btn.classList.remove('active'));

          if (!isActive) {
            this.classList.add('active');
            currentSelectedOptions[`option${optionIndex + 1}`] = value;
            if (selectedValueSpan) {
              selectedValueSpan.textContent = value;
              const selectedMetafields = findSelectedMetafields();
              if (selectedMetafields && selectedMetafields["thierry.color"]) {
                selectedValueSpan.textContent += ` (${selectedMetafields["thierry.color"]})`;
              }
            }
          } else {
            // Clicking an active button deselects it
            currentSelectedOptions[`option${optionIndex + 1}`] = null;
            if (selectedValueSpan) selectedValueSpan.textContent = '';
          }
          updateVariantState();
        });
      });
    });

    function updateVariantState() {
      let allOptionsSelected = true;
      productOptions.forEach((option, index) => {
        if (currentSelectedOptions[`option${index + 1}`] === null) {
          allOptionsSelected = false;
        }
      });

      if (!allOptionsSelected) {
        setButtonState('select_options');
        if (defaultMainImage && mainImageElement) {
          mainImageElement.src = defaultMainImage.src;
          mainImageElement.srcset = defaultMainImage.srcset;
          mainImageElement.alt = defaultMainImage.alt;
        }
        if (variantIdInput) {
          variantIdInput.value = '';
          variantIdInput.disabled = true;
        }
        return;
      }

      const selectedVariant = findSelectedVariant();

      if (selectedVariant) {
        if (variantIdInput) {
          variantIdInput.value = selectedVariant.id;
          variantIdInput.disabled = false;
        }

        if (selectedVariant.featured_image && mainImageElement) {
          const imgSrc = selectedVariant.featured_image.src;
          mainImageElement.src = shopifyImageURL(imgSrc, '533x'); // A common card size

          // Generating srcset dynamically can be complex. This is a simplified version.
          // Ensure your `shopifyImageURL` can handle various size requests.
          const widths = [165, 360, 533, 720, 940, 1066];
          let newSrcset = widths.map(w => {
            if (selectedVariant.featured_image.width >= w) {
              return `${shopifyImageURL(imgSrc, `${w}x`)} ${w}w`;
            }
            return null;
          }).filter(Boolean).join(', ');

          if (newSrcset) {
             mainImageElement.srcset = newSrcset + `, ${shopifyImageURL(imgSrc, '')} ${selectedVariant.featured_image.width}w`;
          } else {
             mainImageElement.srcset = shopifyImageURL(imgSrc, '533x') + ` ${selectedVariant.featured_image.width}w`;
          }
          mainImageElement.alt = selectedVariant.featured_image.alt || productVariants.title || '';
        } else if (defaultMainImage && mainImageElement) {
          // Fallback if variant has no image
          mainImageElement.src = defaultMainImage.src;
          mainImageElement.srcset = defaultMainImage.srcset;
          mainImageElement.alt = defaultMainImage.alt;
        }

        setButtonState(selectedVariant.available ? 'ready' : 'sold_out');

      } else {
        // Combination doesn't exist
        setButtonState('unavailable'); // Or 'select_options' if preferred for invalid combo
        if (defaultMainImage && mainImageElement) { // Revert to default image
          mainImageElement.src = defaultMainImage.src;
          mainImageElement.srcset = defaultMainImage.srcset;
          mainImageElement.alt = defaultMainImage.alt;
        }
        if (variantIdInput) {
          variantIdInput.value = '';
          variantIdInput.disabled = true;
        }
      }
    }

    function findSelectedVariant() {
      return productVariants.find(variant => {
        return productOptions.every((option, index) => {
          return variant[`option${index + 1}`] === currentSelectedOptions[`option${index + 1}`];
        });
      });
    }

    function findSelectedMetafields() {
      const selectedVariant = findSelectedVariant();
      if (selectedVariant) {
        const sku = selectedVariant.sku;
        return productVariantMetafields[sku];
      }
      return {};
    }

    function setButtonState(state) { // 'select_options', 'ready', 'sold_out', 'unavailable'
      if (!addToCartButton || !selectOptionsTextSpan || !readyToCartTextSpan || !soldOutTextSpan) return;

      addToCartButton.disabled = true;
      selectOptionsTextSpan.style.display = 'none';
      readyToCartTextSpan.style.display = 'none';
      soldOutTextSpan.style.display = 'none';

      switch (state) {
        case 'ready':
          addToCartButton.disabled = false;
          readyToCartTextSpan.style.display = 'inline';
          break;
        case 'sold_out':
          soldOutTextSpan.style.display = 'inline';
          break;
        case 'select_options':
        case 'unavailable': // You might want different text for 'unavailable' if needed
        default:
          selectOptionsTextSpan.style.display = 'inline';
          break;
      }
    }

    // Helper to mimic Shopify's image_url filter (basic version)
    function shopifyImageURL(src, size) {
      if (!src) return '';
      if (!size || size === '') return src; // Return original if no size specified
      try {
        // Example: //cdn.shopify.com/s/files/1/.../image.jpg?v=123
        // Becomes: //cdn.shopify.com/s/files/1/.../image_size.jpg?v=123
        const parts = src.split('?');
        const basePath = parts[0];
        const query = parts.length > 1 ? `?${parts[1]}` : '';
        const extensionIndex = basePath.lastIndexOf('.');
        if (extensionIndex === -1) return src; // No extension found

        const name = basePath.substring(0, extensionIndex);
        const ext = basePath.substring(extensionIndex);

        // Remove existing_size_params if any e.g. _100x or _small
        const nameWithoutExistingSize = name.replace(/_(pico|icon|thumb|small|compact|medium|large|grande|original|master|([0-9]+x[0-9]*)|(x[0-9]+)|([0-9]+x))$/, '');

        return `${nameWithoutExistingSize}_${size}${ext}${query}`;
      } catch (e) {
        console.warn("shopifyImageURL error:", e);
        return src; // Fallback to original src on error
      }
    }

    // Initial state
    setButtonState('select_options');
  });
});
